import LensDeBlur from "components/Icons/LensDeBlur";
import { addDataLayer } from "lib/ga";
import { useDispatch, useSelector } from 'react-redux';
import { setShowModal } from 'redux/features/pd/pdSlice';
import { useForm } from 'react-hook-form';
import { RootState } from "redux/store";
import { useEffect, useReducer, useState } from "react";
import axios from 'axios';
import { setNewsletterGuest, setUser } from 'redux/features/auth/authSlice';
import Link from "next/link";
import UIButtonType from "components/Others/UIButtonType";


export default function PDMeterButtonNewsletterBox() {

  type INPUTS = {
    EMAIL: string;
  };
  const newstellerform = useForm<INPUTS>();
  const selectedRegion = useSelector(
    (state: RootState) => state.regionEvent.selectedRegion
  );
  const country = useSelector(
    (state: RootState) => state.regionEvent.country
  );
  const user = useSelector((state: RootState) => state.authEvent.user);
  const newsletterGuest = useSelector((state: RootState) => state.authEvent.newsletterGuest);
  
  const authToken = useSelector(
    (state: RootState) => state.authEvent.authToken
  );
  const isLogin = useSelector((state: RootState) => state.authEvent.isLogin);

  const [newsLetterState, setNewsLetterState] = useState<string>('');


  useEffect(() => {
    if (newsLetterState == "SUCCESS") {
      addDataLayer({ event: 'newsletter_pdmeter_open' }, false);
      dispatch(setShowModal(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsLetterState]);

  const [newsLetterMessage, setnewsLetterMessage] = useState<string>("");

  var checkDataLayerForNewsLetter = false;
  var updateUser = true;

  const updateUserNewsletterSetting = () => {
    if (isLogin && updateUser) {
      updateUser = false;
      axios
        .get(process.env.NEXT_PUBLIC_LARAVEL_URL + '/me/setNewsletterEnable', {
          headers: {
            Authorization: 'Bearer ' + authToken //the token is a variable which holds the token
          }
        })
        .then(() => {
          var newUser = Object.assign({}, user);
          newUser['new_opt_in'] = 'ALL';
          newUser['channel_email'] = true;
          newUser['channel_sms'] = true;
          newUser['channel_phone'] = true;
          dispatch(setUser(newUser));
        });
    } 
  };

  const dataLayerForNewsLetter = () => {
    if (!checkDataLayerForNewsLetter) {
      checkDataLayerForNewsLetter = true;
      addDataLayer({ event: 'newsletter_pdmeter_success' });
    }
    if (!isLogin) {
      dispatch(setNewsletterGuest(true));
    }
  };
  const subscribeNewsLetter = (data: any) => {
    setNewsLetterState('LOADING');
    const userData: any = {
      email: data.EMAIL,
      region: selectedRegion ? selectedRegion.key : 'au',
      regionValue: selectedRegion ? selectedRegion.value : 'Australia',
      country: country,
      source: 'ONLINE_PD_TOOL_PAGE'
    };
    if (user) {
      userData['userId'] = user.ID;
    }
    axios.post(process.env.NEXT_PUBLIC_LARAVEL_URL + '/campaigns/newsletter/create', userData).then((res: any) => {
      setNewsLetterState('SUCCESS');
      setnewsLetterMessage(res.data.message);
      dataLayerForNewsLetter();
      updateUserNewsletterSetting();
    
    }).catch((e: any) => {
      setNewsLetterState('ERROR');
      setnewsLetterMessage(e.response.data.errors.email[0]);
    });
  }
  const dispatch = useDispatch();


  const innerLayout = (children: any) => {
    return (<div className=" lg:min-w-[391px] lgx:mb-4 lgx:mx-auto border lg:mr-6 border-brand-grey500 p-7 rounded-[20px]">
      <LensDeBlur />
      <h3 className="text-lg leading-5 text-brand-black100 font-semibold mt-4 mb-6">Online Pupillary Distance Measurement Tool | Measure Your PD</h3>
      <p className=' text-brand-grey300 text-base'>Our free online pupillary distance measurement tool makes it easy to measure your PD in minutes.</p>

      {children}
    </div>);
  };


  if ((user && user.new_opt_in == 'ALL' && (user.channel_email || user.channel_sms)) || newsletterGuest ) {
    return innerLayout(
      <UIButtonType
        className="mt-10 mx-auto leading-5"
        loading={newsLetterState == "LOADING"}
        onClick={() => {
          //newstellerform.clearErrors();
          addDataLayer({ event: 'newsletter_pdmeter_click' }, false);
          dispatch(setShowModal(true))
        }
        }>
        Use Our Online Tool to Measure your PD
      </UIButtonType>
    )
  }

  return innerLayout(
    <>
      <div className='text-brand-black75 mt-[16px] text-sm font-semibold'>Enter your email address to use online PD tool.</div>
      <div className="text-brand-grey75 mt-2 text-sm">
      You can use the same email even if you have signed up for our newsletter before.
        </div>
      <form
        onSubmit={newstellerform.handleSubmit(subscribeNewsLetter)}
        className="relative mt-[16px] xsmx:w-full">
        <input
          {...newstellerform.register('EMAIL', {
            required: true,
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'invalid email address'
            },
            value: isLogin ? user.email : ''
          })}
          placeholder="Your email"
          className="focus:outline-none h-[48px] w-full rounded-md border-[1px] border-[#CACACA] px-[12px] text-[13px] leading-[38px] placeholder:uppercase"
          readOnly={isLogin}
        />
        {newstellerform.formState.errors.EMAIL && (
          <p className="mt-1 w-full text-left text-xs text-brand-red">
            {newstellerform.formState.errors.EMAIL.type ===
              'pattern'
              ? 'Please enter a valid email address.'
              : 'This field is required.'}
          </p>
        )}
        {newsLetterState == "ERROR" && (
          <p
            className="mt-1 w-full max-w-[250px] text-left text-xs text-brand-red"
            dangerouslySetInnerHTML={{
              __html: newsLetterMessage as string
            }}></p>
        )}
        <div className="text-brand-grey75 mt-2 text-sm">
          By clicking the below button, you agree to <Link target="_blank" href="/terms-and-conditions">subscribe our newsletter</Link>
        </div>
        <UIButtonType
          className="mt-5 mx-auto leading-5"
          type="submit"
          loading={newsLetterState == "LOADING"}
          onClick={() => {
            //newstellerform.clearErrors();
            //addDataLayer({ event: 'newsletter_pdmeter_click' }, false);
            //dispatch(setShowModal(true))
          }
          }>
          Use Our Online Tool to Measure your PD
        </UIButtonType>
      </form>
    </>
  );
}
